import { useAuth } from "@/domains/shared/hooks/useAuth";
import { postAuthHomePath } from "@/domains/shared/services/emailVerification";
import { Navigate } from "react-router";

export default function AppRootRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 border-2 border-border border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (user) {
    return <Navigate to={postAuthHomePath(user)} replace />;
  }

  return <Navigate to="/login" replace />;
}
